import accessControlEvents from '@features/access-control-events/locales/pl';
import accessControlProfiles from '@features/access-control-profiles/locales/pl';
import auth from '@features/auth/locales/pl';
import billingGroups from '@features/billing-groups/locales/pl';
import destinationGroups from '@features/destination-groups/locales/pl';
import destinations from '@features/destinations/locales/pl';
import hosts from '@features/hosts/locales/pl';
import organizationAdmins from '@features/organization-admins/locales/pl';
import settings from '@features/settings/locales/pl';
import visits from '@features/visits/locales/pl';

import common from './common.json';
import validation from './validation.json';

const resources = {
  common,
  validation,
  ...visits,
  ...accessControlEvents,
  ...accessControlProfiles,
  ...billingGroups,
  ...destinationGroups,
  ...destinations,
  ...organizationAdmins,
  ...settings,
  ...hosts,
  ...auth,
} as const;

export default resources;
